/**
 * Default secure cookie options for consistency across the application
 * @param {Object} overrides - Additional options to override defaults
 * @returns {Object} Cookie options object
 */
export function getSecureCookieOptions(overrides = {}) {
  return {
    maxAge: 60 * 60 * 24 * 30, // 30 days
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'lax',
    ...overrides
  }
}
